import {
  ANNUAL_RETURNS_DECLARATIONS_ROUTES,
  APPLICATION_FOR_FS_EXEMPTION_ROUTES,
  CESSATION_DISSOLUTION_ROUTES,
  COMMON_SHARES_ROUTE,
  ENTITY_REGISTRATION_ROUTES,
  ENTITY_RENEWAL_ROUTES,
  EXTENSION_OF_TIME_ROUTES,
  FINANCIAL_YEAR_END_ROUTES,
  GENERAL_LODGEMENT_ROUTES,
  INITIATION_OF_WINDING_UP_ROUTES,
  MAINTENANCE_OF_REGISTRABLE_CONTROLLERS_ROUTES,
  NAME_APPLICATION_ROUTES,
  OBJ_STRIKING_OFF_ROUTES,
  POST_INITIATION_OF_WINDING_UP_ROUTES,
  POST_STRIKE_OFF_ROUTES,
  REDUCTION_SHARE_CAPITAL_ROUTES,
  REGISTER_CORPORATE_SERVICE_PROVIDER_ROUTES,
  REGISTER_PUBLIC_ACCOUNTANT_ROUTES,
  REGISTER_QUALIFIED_INDIVIDUAL_ROUTES,
  REGISTRATION_OF_CHARGES_ROUTES,
  RENEW_CSP_ROUTES,
  RENEW_PUBLIC_ACCOUNTANT_ROUTES,
  RENEW_QUALIFIED_INDIVIDUAL_ROUTES,
  STRIKE_OFF_ROUTES,
  UPDATE_PERSONNEL_ROUTES,
  UPDATE_SHAREHOLDER_ROUTES,
  VARIATION_SATISFACTION_ROUTES,
  NOTICE_OF_ERROR_ROUTES,
  NOMINATOR_INFORMATION_ROUTES
} from './routes';

export const MODULE_ROUTES = {
  ANNUAL_FILING: 'annual-filing',
  DEREGISTER: 'deregister',
  MANAGE: 'manage',
  OTHERS: 'others',
  REGISTER: 'register',
  REGISTRY: 'registry',
};

export const INSTRUCTION_PAGE_MODULES = {
  NAME_APPLICATION: NAME_APPLICATION_ROUTES.NAME_APPLICATION,
  ENTITY_REGISTRATION: ENTITY_REGISTRATION_ROUTES.ENTITY_REGISTRATION,
  ANNUAL_RETURNS_DECLARATIONS: ANNUAL_RETURNS_DECLARATIONS_ROUTES.FILE_ARAD,
  REDUCTION_SHARE_CAPITAL: REDUCTION_SHARE_CAPITAL_ROUTES.REDUCTION_SHARE_CAPITAL,
  UPDATE_PERSONNEL: UPDATE_PERSONNEL_ROUTES.UPDATE_PERSONNEL,
  CESSATION_DISSOLUTION: CESSATION_DISSOLUTION_ROUTES.CESSATION_DISSOLUTION,
  ENTITY_RENEWAL: ENTITY_RENEWAL_ROUTES.ENTITY_RENEWAL,
  STRIKE_OFF: STRIKE_OFF_ROUTES.STRIKE_OFF,
  OBJ_STRIKING_OFF: OBJ_STRIKING_OFF_ROUTES.OBJ_STRIKING_OFF,
  POST_STRIKE_OFF: POST_STRIKE_OFF_ROUTES.POST_STRIKE_OFF,
  REGISTER_PUBLIC_ACCOUNTANT: REGISTER_PUBLIC_ACCOUNTANT_ROUTES.PUBLIC_ACCOUNTANT,
  APPLICATION_FOR_FS_EXEMPTION: APPLICATION_FOR_FS_EXEMPTION_ROUTES.APPLICATION_FOR_FS_EXEMPTION,
  RENEW_PUBLIC_ACCOUNTANT: RENEW_PUBLIC_ACCOUNTANT_ROUTES.PUBLIC_ACCOUNTANT,
  REGISTER_CORPORATE_SERVICE_PROVIDER: REGISTER_CORPORATE_SERVICE_PROVIDER_ROUTES.REGISTER_CSR,
  REGISTER_QUALIFIED_INDIVIDUAL: REGISTER_QUALIFIED_INDIVIDUAL_ROUTES.REGISTER_RQI,
  UPDATE_SHAREHOLDER: UPDATE_SHAREHOLDER_ROUTES.UPDATE_SHAREHOLDER,
  RENEW_CSP: RENEW_CSP_ROUTES.RENEW_CSP,
  RENEW_QUALIFIED_INDIVIDUAL: RENEW_QUALIFIED_INDIVIDUAL_ROUTES.RENEW_RQI,
  REGISTRATION_OF_CHARGES: REGISTRATION_OF_CHARGES_ROUTES.REGISTRATION_OF_CHARGES,
  INITIATION_OF_WINDING_UP: INITIATION_OF_WINDING_UP_ROUTES.INITIATION_OF_WINDING_UP,
  POST_INITIATION_OF_WINDING_UP: POST_INITIATION_OF_WINDING_UP_ROUTES.POST_INITIATION_OF_WINDING_UP,
  MAINTENANCE_OF_RORC: MAINTENANCE_OF_REGISTRABLE_CONTROLLERS_ROUTES.MAINTENANCE_OF_RORC,
  EXTENSION_OF_TIME: EXTENSION_OF_TIME_ROUTES.EXTENSION_OF_TIME,
  VARIATION_SATISFACTION: VARIATION_SATISFACTION_ROUTES.VARIATION_SATISFACTION,
  FINANCIAL_YEAR_END: FINANCIAL_YEAR_END_ROUTES.FYE,
  NOTICE_OF_ERROR: NOTICE_OF_ERROR_ROUTES.NOE,
  UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS: NOMINATOR_INFORMATION_ROUTES.UPDATE_NOMINATOR
}

export const INSTRUCTION_PAGE_ROUTES = {
  NAME_APPLICATION: `/${MODULE_ROUTES.REGISTRY}/${NAME_APPLICATION_ROUTES.NAME_APPLICATION}/${NAME_APPLICATION_ROUTES.INSTRUCTION_PAGE}`,
  ENTITY_REGISTRATION: `/${MODULE_ROUTES.REGISTRY}/${ENTITY_REGISTRATION_ROUTES.ENTITY_REGISTRATION}/${ENTITY_REGISTRATION_ROUTES.INSTRUCTION_PAGE}`,
  ANNUAL_RETURNS_DECLARATIONS: `/${MODULE_ROUTES.REGISTRY}/${ANNUAL_RETURNS_DECLARATIONS_ROUTES.FILE_ARAD}/${ANNUAL_RETURNS_DECLARATIONS_ROUTES.INSTRUCTION_PAGE}`,
  REDUCTION_SHARE_CAPITAL: `/${MODULE_ROUTES.REGISTRY}/${REDUCTION_SHARE_CAPITAL_ROUTES.REDUCTION_SHARE_CAPITAL}/${REDUCTION_SHARE_CAPITAL_ROUTES.OVERVIEW_PAGE}`,
  INITIATION_OF_WINDING_UP: `/${MODULE_ROUTES.REGISTRY}/${INITIATION_OF_WINDING_UP_ROUTES.INITIATION_OF_WINDING_UP}/${INITIATION_OF_WINDING_UP_ROUTES.INSTRUCTION_PAGE}`,
  POST_INITIATION_OF_WINDING_UP: `/${MODULE_ROUTES.REGISTRY}/${POST_INITIATION_OF_WINDING_UP_ROUTES.POST_INITIATION_OF_WINDING_UP}/${POST_INITIATION_OF_WINDING_UP_ROUTES.INSTRUCTION_PAGE}`,
  UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL: `/${MODULE_ROUTES.REGISTRY}/${UPDATE_PERSONNEL_ROUTES.UPDATE_PERSONNEL}/${UPDATE_PERSONNEL_ROUTES.APPOINT_WITHDRAW_INSTRUCTION_PAGE}`,
  UPDATE_PERSONNEL_EDIT_PERSONNEL: `/${MODULE_ROUTES.REGISTRY}/${UPDATE_PERSONNEL_ROUTES.UPDATE_PERSONNEL}/${UPDATE_PERSONNEL_ROUTES.EDIT_PERSONNEL_INSTRUCTION_PAGE}`,
  CESSATION_DISSOLUTION: `/${MODULE_ROUTES.REGISTRY}/${CESSATION_DISSOLUTION_ROUTES.CESSATION_DISSOLUTION}/${CESSATION_DISSOLUTION_ROUTES.INSTRUCTION_PAGE}`,
  STRIKE_OFF: `/${MODULE_ROUTES.REGISTRY}/${STRIKE_OFF_ROUTES.STRIKE_OFF}/${STRIKE_OFF_ROUTES.INSTRUCTION_PAGE}`,
  ENTITY_RENEWAL: `/${MODULE_ROUTES.REGISTRY}/${ENTITY_RENEWAL_ROUTES.ENTITY_RENEWAL}/${ENTITY_RENEWAL_ROUTES.INSTRUCTION_PAGE}`,
  OBJ_STRIKING_OFF: `/${MODULE_ROUTES.REGISTRY}/${OBJ_STRIKING_OFF_ROUTES.OBJ_STRIKING_OFF}/${OBJ_STRIKING_OFF_ROUTES.INSTRUCTION_PAGE}`,
  POST_STRIKE_OFF: `/${MODULE_ROUTES.REGISTRY}/${POST_STRIKE_OFF_ROUTES.POST_STRIKE_OFF}/${POST_STRIKE_OFF_ROUTES.INSTRUCTION_PAGE}`,
  REGISTER_PUBLIC_ACCOUNTANT: `/${MODULE_ROUTES.REGISTRY}/${REGISTER_PUBLIC_ACCOUNTANT_ROUTES.PUBLIC_ACCOUNTANT}/${REGISTER_PUBLIC_ACCOUNTANT_ROUTES.INSTRUCTION_PAGE}`,
  APPLICATION_FOR_FS_EXEMPTION: `/${MODULE_ROUTES.REGISTRY}/${APPLICATION_FOR_FS_EXEMPTION_ROUTES.APPLICATION_FOR_FS_EXEMPTION}/${APPLICATION_FOR_FS_EXEMPTION_ROUTES.INSTRUCTION_PAGE}`,
  RENEW_PUBLIC_ACCOUNTANT: `/${MODULE_ROUTES.REGISTRY}/${RENEW_PUBLIC_ACCOUNTANT_ROUTES.PUBLIC_ACCOUNTANT}/${RENEW_PUBLIC_ACCOUNTANT_ROUTES.INSTRUCTION_PAGE}`,
  REGISTER_CORPORATE_SERVICE_PROVIDER: `/${MODULE_ROUTES.REGISTRY}/${REGISTER_CORPORATE_SERVICE_PROVIDER_ROUTES.REGISTER_CSR}/${REGISTER_CORPORATE_SERVICE_PROVIDER_ROUTES.INSTRUCTION_PAGE}`,
  UPDATE_SHAREHOLDER: `/${MODULE_ROUTES.REGISTRY}/${UPDATE_SHAREHOLDER_ROUTES.UPDATE_SHAREHOLDER}/${UPDATE_SHAREHOLDER_ROUTES.INSTRUCTION_PAGE}`,
  REGISTER_QUALIFIED_INDIVIDUAL: `/${MODULE_ROUTES.REGISTRY}/${REGISTER_QUALIFIED_INDIVIDUAL_ROUTES.REGISTER_RQI}/${REGISTER_QUALIFIED_INDIVIDUAL_ROUTES.INSTRUCTION_PAGE}`,
  RENEW_CSP: `/${MODULE_ROUTES.REGISTRY}/${RENEW_CSP_ROUTES.RENEW_CSP}/${RENEW_CSP_ROUTES.INSTRUCTION_PAGE}`,
  RENEW_QUALIFIED_INDIVIDUAL: `/${MODULE_ROUTES.REGISTRY}/${RENEW_QUALIFIED_INDIVIDUAL_ROUTES.RENEW_RQI}/${RENEW_QUALIFIED_INDIVIDUAL_ROUTES.INSTRUCTION_PAGE}`,
  REGISTRATION_OF_CHARGES: `/${MODULE_ROUTES.REGISTRY}/${REGISTRATION_OF_CHARGES_ROUTES.REGISTRATION_OF_CHARGES}/${REGISTRATION_OF_CHARGES_ROUTES.INSTRUCTION_PAGE}`,
  GENERAL_LODGEMENT: `/${MODULE_ROUTES.REGISTRY}/${GENERAL_LODGEMENT_ROUTES.GENERAL_LODGEMENT}/${GENERAL_LODGEMENT_ROUTES.INSTRUCTION_PAGE}`,
  MAINTENANCE_OF_RORC: `/${MODULE_ROUTES.REGISTRY}/${MAINTENANCE_OF_REGISTRABLE_CONTROLLERS_ROUTES.MAINTENANCE_OF_RORC}/${MAINTENANCE_OF_REGISTRABLE_CONTROLLERS_ROUTES.INSTRUCTION_PAGE}`,
  COMMON_SHARES: `/${MODULE_ROUTES.REGISTRY}/${COMMON_SHARES_ROUTE.SHARES}`,
  EXTENSION_OF_TIME: `/${MODULE_ROUTES.REGISTRY}/${EXTENSION_OF_TIME_ROUTES.EXTENSION_OF_TIME}/${EXTENSION_OF_TIME_ROUTES.INSTRUCTION}`,
  VARIATION_SATISFACTION: `/${MODULE_ROUTES.REGISTRY}/${VARIATION_SATISFACTION_ROUTES.VARIATION_SATISFACTION}/${VARIATION_SATISFACTION_ROUTES.INSTRUCTION}`,
  FINANCIAL_YEAR_END: `/${MODULE_ROUTES.REGISTRY}/${FINANCIAL_YEAR_END_ROUTES.FYE}/${VARIATION_SATISFACTION_ROUTES.INSTRUCTION}`,
  NOTICE_OF_ERROR: `/${MODULE_ROUTES.REGISTRY}/${NOTICE_OF_ERROR_ROUTES.NOE}/${NOTICE_OF_ERROR_ROUTES.INSTRUCTION}`,
  UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS: `/${MODULE_ROUTES.REGISTRY}/${NOMINATOR_INFORMATION_ROUTES.UPDATE_NOMINATOR}/${NOMINATOR_INFORMATION_ROUTES.INSTRUCTION}`
};
